import { mergeRpcOptions, Deferred, UnaryCall, RpcError, DeferredState } from '@protobuf-ts/runtime-rpc';
import { v4 } from 'uuid';
import { EventEmitter } from 'eventemitter3';
import { Logger } from '@streamr/utils';
import { MessageType, jsonWriteOptions, isJsonObject, typeofJsonValue, reflectionMergePartial, UnknownFieldHandler, WireType } from '@protobuf-ts/runtime';

/* eslint-disable max-len */
var ErrorCode;
(function (ErrorCode) {
    ErrorCode["RPC_TIMEOUT"] = "RPC_TIMEOUT";
    ErrorCode["RPC_REQUEST"] = "RPC_REQUEST";
    ErrorCode["RPC_SERVER_ERROR"] = "RPC_SERVER_ERROR";
    ErrorCode["RPC_CLIENT_ERROR"] = "RPC_CLIENT_ERROR";
    ErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
    ErrorCode["UNKNOWN_RPC_METHOD"] = "UNKNOWN_RPC_METHOD";
    ErrorCode["FAILED_TO_PARSE"] = "FAILED_TO_PARSE";
    ErrorCode["FAILED_TO_SERIALIZE"] = "FAILED_TO_SERIALIZE";
    ErrorCode["DISCONNECTED"] = "DISCONNECTED";
})(ErrorCode || (ErrorCode = {}));
class Err extends Error {
    code;
    originalError;
    constructor(code, message, originalError) {
        super(message);
        this.code = code;
        this.originalError = originalError;
    }
}
class RpcTimeout extends Err {
    constructor(message, originalError) { super(ErrorCode.RPC_TIMEOUT, message, originalError); }
}
class RpcRequest extends Err {
    constructor(message, originalError) { super(ErrorCode.RPC_REQUEST, message, originalError); }
}
class RpcServerError extends Err {
    errorClassName;
    errorCode;
    constructor(errorMessage, errorClassName, errorCode) {
        super(ErrorCode.RPC_SERVER_ERROR, errorMessage);
        this.errorClassName = errorClassName;
        this.errorCode = errorCode;
    }
}
class RpcClientError extends Err {
    constructor(message, originalError) { super(ErrorCode.RPC_CLIENT_ERROR, message, originalError); }
}
class NotImplemented extends Err {
    constructor(message, originalError) { super(ErrorCode.NOT_IMPLEMENTED, message, originalError); }
}
let UnknownRpcMethod$1 = class UnknownRpcMethod extends Err {
    constructor(message, originalError) { super(ErrorCode.UNKNOWN_RPC_METHOD, message, originalError); }
};
class FailedToParse extends Err {
    constructor(message, originalError) { super(ErrorCode.FAILED_TO_PARSE, message, originalError); }
}
class FailedToSerialize extends Err {
    constructor(message, originalError) { super(ErrorCode.FAILED_TO_SERIALIZE, message, originalError); }
}
class Disconnected extends Err {
    constructor(message, originalError) { super(ErrorCode.DISCONNECTED, message, originalError); }
}

var errors = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Disconnected: Disconnected,
    get ErrorCode () { return ErrorCode; },
    FailedToParse: FailedToParse,
    FailedToSerialize: FailedToSerialize,
    NotImplemented: NotImplemented,
    RpcClientError: RpcClientError,
    RpcRequest: RpcRequest,
    RpcServerError: RpcServerError,
    RpcTimeout: RpcTimeout,
    UnknownRpcMethod: UnknownRpcMethod$1
});

// @generated message type with reflection information, may provide speed optimized methods
class Any$Type extends MessageType {
    constructor() {
        super("google.protobuf.Any", [
            { no: 1, name: "type_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "value", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    /**
     * Pack the message into a new `Any`.
     *
     * Uses 'type.googleapis.com/full.type.name' as the type URL.
     */
    pack(message, type) {
        return {
            typeUrl: this.typeNameToUrl(type.typeName), value: type.toBinary(message),
        };
    }
    /**
     * Unpack the message from the `Any`.
     */
    unpack(any, type, options) {
        if (!this.contains(any, type))
            throw new Error("Cannot unpack google.protobuf.Any with typeUrl '" + any.typeUrl + "' as " + type.typeName + ".");
        return type.fromBinary(any.value, options);
    }
    /**
     * Does the given `Any` contain a packed message of the given type?
     */
    contains(any, type) {
        if (!any.typeUrl.length)
            return false;
        let wants = typeof type == "string" ? type : type.typeName;
        let has = this.typeUrlToName(any.typeUrl);
        return wants === has;
    }
    /**
     * Convert the message to canonical JSON value.
     *
     * You have to provide the `typeRegistry` option so that the
     * packed message can be converted to JSON.
     *
     * The `typeRegistry` option is also required to read
     * `google.protobuf.Any` from JSON format.
     */
    internalJsonWrite(any, options) {
        if (any.typeUrl === "")
            return {};
        let typeName = this.typeUrlToName(any.typeUrl);
        let opt = jsonWriteOptions(options);
        let type = opt.typeRegistry?.find(t => t.typeName === typeName);
        if (!type)
            throw new globalThis.Error("Unable to convert google.protobuf.Any with typeUrl '" + any.typeUrl + "' to JSON. The specified type " + typeName + " is not available in the type registry.");
        let value = type.fromBinary(any.value, { readUnknownField: false });
        let json = type.internalJsonWrite(value, opt);
        if (typeName.startsWith("google.protobuf.") || !isJsonObject(json))
            json = { value: json };
        json["@type"] = any.typeUrl;
        return json;
    }
    internalJsonRead(json, options, target) {
        if (!isJsonObject(json))
            throw new globalThis.Error("Unable to parse google.protobuf.Any from JSON " + typeofJsonValue(json) + ".");
        if (typeof json["@type"] != "string" || json["@type"] == "")
            return this.create();
        let typeName = this.typeUrlToName(json["@type"]);
        let type = options?.typeRegistry?.find(t => t.typeName == typeName);
        if (!type)
            throw new globalThis.Error("Unable to parse google.protobuf.Any from JSON. The specified type " + typeName + " is not available in the type registry.");
        let value;
        if (typeName.startsWith("google.protobuf.") && json.hasOwnProperty("value"))
            value = type.fromJson(json["value"], options);
        else {
            let copy = Object.assign({}, json);
            delete copy["@type"];
            value = type.fromJson(copy, options);
        }
        if (target === undefined)
            target = this.create();
        target.typeUrl = json["@type"];
        target.value = type.toBinary(value);
        return target;
    }
    typeNameToUrl(name) {
        if (!name.length)
            throw new Error("invalid type name: " + name);
        return "type.googleapis.com/" + name;
    }
    typeUrlToName(url) {
        if (!url.length)
            throw new Error("invalid type url: " + url);
        let slash = url.lastIndexOf("/");
        let name = slash > 0 ? url.substring(slash + 1) : url;
        if (!name.length)
            throw new Error("invalid type url: " + url);
        return name;
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.typeUrl = "";
        message.value = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string type_url */ 1:
                    message.typeUrl = reader.string();
                    break;
                case /* bytes value */ 2:
                    message.value = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string type_url = 1; */
        if (message.typeUrl !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.typeUrl);
        /* bytes value = 2; */
        if (message.value.length)
            writer.tag(2, WireType.LengthDelimited).bytes(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message google.protobuf.Any
 */
const Any = new Any$Type();

const logger$2 = new Logger('ClientTransport');
class ClientTransport extends EventEmitter {
    static objectCount = 0;
    objectId;
    defaultOptions;
    constructor(defaultTimeout = 5000) {
        super();
        this.objectId = ClientTransport.objectCount++;
        this.defaultOptions = {
            timeout: defaultTimeout,
            clientId: this.objectId
        };
    }
    mergeOptions(options) {
        return mergeRpcOptions(this.defaultOptions, options);
    }
    static createRequestHeaders(method, notification) {
        return {
            method: method.localName,
            request: 'request',
            notification: notification ? 'notification' : undefined
        };
    }
    unary(method, input, options) {
        if (!options?.isProtoRpc) {
            // eslint-disable-next-line max-len
            throw new Error('ProtoRpc ClientTransport can only be used with ProtoRpcClients. Please convert your protobuf-ts generated client to a ProtoRpcClient by calling toProtoRpcclient(yourClient).');
        }
        const requestBody = Any.pack(input, method.I);
        const request = {
            header: ClientTransport.createRequestHeaders(method, options.notification),
            body: requestBody,
            requestId: v4()
        };
        const defHeader = new Deferred();
        const defMessage = new Deferred();
        const defStatus = new Deferred();
        const defTrailer = new Deferred();
        const unary = new UnaryCall(method, {}, input, defHeader.promise, defMessage.promise, defStatus.promise, defTrailer.promise);
        const deferredParser = (bytes) => method.O.fromBinary(bytes);
        const deferred = {
            message: defMessage,
            header: defHeader,
            trailer: defTrailer,
            status: defStatus,
            messageParser: deferredParser
        };
        logger$2.trace(`New rpc ${options.notification ? 'notification' : 'request'}, ${request.requestId}`);
        this.emit('rpcRequest', request, options, deferred);
        return unary;
    }
    // eslint-disable-next-line class-methods-use-this
    clientStreaming(method) {
        const e = new RpcError('Client streaming is not supported by DhtTransport');
        e.methodName = method.name;
        e.serviceName = method.service.typeName;
        throw e;
    }
    // eslint-disable-next-line class-methods-use-this
    duplex(method) {
        const e = new RpcError('Duplex streaming is not supported by DhtTransport');
        e.methodName = method.name;
        e.serviceName = method.service.typeName;
        throw e;
    }
    // eslint-disable-next-line class-methods-use-this
    serverStreaming(method) {
        const e = new RpcError('Server streaming is not supported by DhtTransport');
        e.methodName = method.name;
        e.serviceName = method.service.typeName;
        throw e;
    }
    stop() {
        this.removeAllListeners();
    }
}

// @generated message type with reflection information, may provide speed optimized methods
class Empty$Type extends MessageType {
    constructor() {
        super("google.protobuf.Empty", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message google.protobuf.Empty
 */
const Empty = new Empty$Type();

// @generated by protobuf-ts 2.11.1 with parameter server_generic,generate_dependencies
// @generated from protobuf file "ProtoRpc.proto" (package "protorpc", syntax proto3)
// tslint:disable
/**
 * @generated from protobuf enum protorpc.RpcErrorType
 */
var RpcErrorType;
(function (RpcErrorType) {
    /**
     * @generated from protobuf enum value: SERVER_TIMEOUT = 0;
     */
    RpcErrorType[RpcErrorType["SERVER_TIMEOUT"] = 0] = "SERVER_TIMEOUT";
    /**
     * @generated from protobuf enum value: CLIENT_TIMEOUT = 1;
     */
    RpcErrorType[RpcErrorType["CLIENT_TIMEOUT"] = 1] = "CLIENT_TIMEOUT";
    /**
     * @generated from protobuf enum value: UNKNOWN_RPC_METHOD = 2;
     */
    RpcErrorType[RpcErrorType["UNKNOWN_RPC_METHOD"] = 2] = "UNKNOWN_RPC_METHOD";
    /**
     * @generated from protobuf enum value: CLIENT_ERROR = 3;
     */
    RpcErrorType[RpcErrorType["CLIENT_ERROR"] = 3] = "CLIENT_ERROR";
    /**
     * @generated from protobuf enum value: SERVER_ERROR = 4;
     */
    RpcErrorType[RpcErrorType["SERVER_ERROR"] = 4] = "SERVER_ERROR";
})(RpcErrorType || (RpcErrorType = {}));
// @generated message type with reflection information, may provide speed optimized methods
class RpcMessage$Type extends MessageType {
    constructor() {
        super("protorpc.RpcMessage", [
            { no: 1, name: "header", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } },
            { no: 2, name: "body", kind: "message", T: () => Any },
            { no: 3, name: "requestId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "errorType", kind: "enum", opt: true, T: () => ["protorpc.RpcErrorType", RpcErrorType] },
            { no: 5, name: "errorClassName", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "errorCode", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "errorMessage", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message protorpc.RpcMessage
 */
const RpcMessage = new RpcMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Mnfo2uhnf92hvqi2nviouq2hv9puhq$Type extends MessageType {
    constructor() {
        super("protorpc.Mnfo2uhnf92hvqi2nviouq2hv9puhq", [
            { no: 1, name: "empty", kind: "message", T: () => Empty }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message protorpc.Mnfo2uhnf92hvqi2nviouq2hv9puhq
 */
new Mnfo2uhnf92hvqi2nviouq2hv9puhq$Type();

// TODO: Replace with streamr-utils library import
function promiseTimeout(ms, givenPromise) {
    const timeoutPromise = new Promise((_resolve, reject) => {
        const timeoutRef = setTimeout(() => {
            reject(new RpcTimeout('Timed out in ' + ms + 'ms.'));
        }, ms);
        // Clear timeout if promise wins race
        givenPromise
            .finally(() => clearTimeout(timeoutRef))
            .catch(() => null);
    });
    return Promise.race([
        givenPromise,
        timeoutPromise
    ]);
}

/* eslint-disable class-methods-use-this */
class ProtoCallContext {
    // implementation of the extended interfaces
    method = undefined;
    headers = undefined;
    deadline = undefined;
    trailers = undefined;
    status = undefined;
    sendResponseHeaders(_data) {
        throw new NotImplemented('Method not implemented.');
    }
    cancelled = undefined;
    onCancel(_cb) {
        throw new NotImplemented('Method not implemented.');
    }
    notification;
}

var UnknownRpcMethod = UnknownRpcMethod$1;
const DEFAULT_TIMEOUT = 1000;
const parseOptions = (options) => {
    return {
        timeout: options.timeout ?? DEFAULT_TIMEOUT
    };
};
const logger$1 = new Logger('ServerRegistry');
function parseWrapper(parseFn) {
    try {
        return parseFn();
    }
    catch (err) {
        throw new FailedToParse(`Could not parse binary to JSON-object`, err);
    }
}
class ServerRegistry {
    methods = new Map();
    notifications = new Map();
    // eslint-disable-next-line class-methods-use-this
    getImplementation(rpcMessage, map) {
        if (!rpcMessage?.header?.method) {
            throw new UnknownRpcMethod('Header "method" missing from RPC message');
        }
        if (!map.has(rpcMessage.header.method)) {
            throw new UnknownRpcMethod(`RPC Method ${rpcMessage.header.method} is not provided`);
        }
        return map.get(rpcMessage.header.method);
    }
    async handleRequest(rpcMessage, callContext) {
        logger$1.trace(`Server processing RPC call ${rpcMessage.requestId}`);
        const implementation = this.getImplementation(rpcMessage, this.methods);
        const timeout = implementation.options.timeout;
        return await promiseTimeout(timeout, implementation.fn(rpcMessage.body, callContext ?? new ProtoCallContext()));
    }
    async handleNotification(rpcMessage, callContext) {
        logger$1.trace(`Server processing RPC notification ${rpcMessage.requestId}`);
        const implementation = this.getImplementation(rpcMessage, this.notifications);
        const timeout = implementation.options.timeout;
        await promiseTimeout(timeout, implementation.fn(rpcMessage.body, callContext ?? new ProtoCallContext()));
    }
    registerRpcMethod(requestClass, returnClass, name, fn, opts = {}) {
        const options = parseOptions(opts);
        const method = {
            fn: async (data, callContext) => {
                const request = parseWrapper(() => Any.unpack(data, requestClass));
                const response = await fn(request, callContext);
                return Any.pack(response, returnClass);
            },
            options
        };
        this.methods.set(name, method);
    }
    registerRpcNotification(requestClass, name, fn, opts = {}) {
        const options = parseOptions(opts);
        const notification = {
            fn: async (data, callContext) => {
                const request = parseWrapper(() => Any.unpack(data, requestClass));
                await fn(request, callContext);
            },
            options
        };
        this.notifications.set(name, notification);
    }
}

/* eslint-disable promise/catch-or-return */
var StatusCode;
(function (StatusCode) {
    StatusCode["OK"] = "OK";
    StatusCode["STOPPED"] = "STOPPED";
    StatusCode["DEADLINE_EXCEEDED"] = "DEADLINE_EXCEEDED";
    StatusCode["SERVER_ERROR"] = "SERVER_ERROR";
})(StatusCode || (StatusCode = {}));
class OngoingRequest {
    deferredPromises;
    callContext;
    timeoutRef;
    constructor(deferredPromises, callContext, timeoutOptions) {
        this.deferredPromises = deferredPromises;
        this.callContext = callContext;
        if (timeoutOptions) {
            this.timeoutRef = setTimeout(() => {
                const error = new RpcTimeout('Rpc request timed out', new Error());
                this.rejectDeferredPromises(error, StatusCode.DEADLINE_EXCEEDED);
                timeoutOptions.onTimeout();
            }, timeoutOptions.timeout);
        }
    }
    resolveRequest(response) {
        if (this.timeoutRef) {
            clearTimeout(this.timeoutRef);
        }
        this.resolveDeferredPromises(response);
    }
    resolveNotification() {
        if (this.timeoutRef) {
            clearTimeout(this.timeoutRef);
        }
        if (this.deferredPromises.message.state === DeferredState.PENDING) {
            this.deferredPromises.message.resolve({});
            this.deferredPromises.header.resolve({});
            this.deferredPromises.status.resolve({ code: StatusCode.OK, detail: '' });
            this.deferredPromises.trailer.resolve({});
        }
    }
    rejectRequest(error, code) {
        if (this.timeoutRef) {
            clearTimeout(this.timeoutRef);
        }
        this.rejectDeferredPromises(error, code);
    }
    resolveDeferredPromises(response) {
        if (this.deferredPromises.message.state === DeferredState.PENDING) {
            try {
                const parsedResponse = this.deferredPromises.messageParser(response.body.value);
                this.deferredPromises.message.resolve(parsedResponse);
                this.deferredPromises.header.resolve({});
                this.deferredPromises.status.resolve({ code: StatusCode.OK, detail: '' });
                this.deferredPromises.trailer.resolve({});
            }
            catch (err) {
                logger.debug(`Could not parse response, received message is likely `);
                const error = new FailedToParse(`Failed to parse received response, network protocol version likely is likely incompatible`, err);
                this.rejectDeferredPromises(error, StatusCode.SERVER_ERROR);
            }
        }
    }
    rejectDeferredPromises(error, code) {
        if (this.deferredPromises.message.state === DeferredState.PENDING) {
            this.deferredPromises.message.reject(error);
            this.deferredPromises.header.reject(error);
            this.deferredPromises.status.reject({ code, detail: error.message });
            this.deferredPromises.trailer.reject(error);
        }
    }
    fulfillsPredicate(predicate) {
        return predicate(this);
    }
    getCallContext() {
        return this.callContext;
    }
}
const logger = new Logger('RpcCommunicator');
class RpcCommunicator {
    stopped = false;
    rpcClientTransport;
    rpcServerRegistry;
    ongoingRequests;
    rpcRequestTimeout;
    outgoingMessageListener;
    constructor(params) {
        this.rpcRequestTimeout = params?.rpcRequestTimeout ?? 5000;
        this.rpcClientTransport = new ClientTransport(this.rpcRequestTimeout);
        this.rpcServerRegistry = new ServerRegistry();
        this.ongoingRequests = new Map();
        // Client side listener for outgoing request
        this.rpcClientTransport.on('rpcRequest', (rpcMessage, options, deferredPromises) => {
            this.onOutgoingMessage(rpcMessage, options, deferredPromises);
        });
    }
    async handleIncomingMessage(message, callContext) {
        if (this.stopped) {
            return;
        }
        return this.onIncomingMessage(message, callContext);
    }
    registerRpcMethod(requestClass, returnClass, name, fn, options = {}) {
        this.rpcServerRegistry.registerRpcMethod(requestClass, returnClass, name, fn, options);
    }
    registerRpcNotification(requestClass, name, fn, options = {}) {
        this.rpcServerRegistry.registerRpcNotification(requestClass, name, fn, options);
    }
    getRpcClientTransport() {
        return this.rpcClientTransport;
    }
    stop() {
        this.stopped = true;
        this.ongoingRequests.forEach((ongoingRequest) => {
            ongoingRequest.rejectRequest(new Error('stopped'), StatusCode.STOPPED);
        });
        this.ongoingRequests.clear();
        this.rpcClientTransport.stop();
    }
    onOutgoingMessage(rpcMessage, callContext, deferredPromises) {
        if (this.stopped) {
            if (deferredPromises) {
                const ongoingRequest = new OngoingRequest(deferredPromises, callContext);
                ongoingRequest.rejectRequest(new Error('stopped'), StatusCode.STOPPED);
            }
            return;
        }
        const requestOptions = this.rpcClientTransport.mergeOptions(callContext);
        // do not register a notification
        if (deferredPromises && (!callContext || !callContext.notification)) {
            this.registerRequest(rpcMessage.requestId, deferredPromises, callContext, requestOptions.timeout);
        }
        logger.trace(`onOutGoingMessage, messageId: ${rpcMessage.requestId}`);
        if (this.outgoingMessageListener) {
            this.outgoingMessageListener(rpcMessage, rpcMessage.requestId, callContext)
                .catch((clientSideException) => {
                if (deferredPromises) {
                    if (this.ongoingRequests.has(rpcMessage.requestId)) {
                        this.handleClientError(rpcMessage.requestId, clientSideException);
                    }
                    else {
                        const ongoingRequest = new OngoingRequest(deferredPromises, callContext);
                        ongoingRequest.rejectRequest(clientSideException, StatusCode.SERVER_ERROR);
                    }
                }
            })
                .then(() => {
                if (deferredPromises) {
                    if (!this.ongoingRequests.has(rpcMessage.requestId)) {
                        const ongoingRequest = new OngoingRequest(deferredPromises, callContext);
                        ongoingRequest.resolveNotification();
                    }
                }
            });
        }
        else if (deferredPromises) {
            if (!this.ongoingRequests.has(rpcMessage.requestId)) {
                const ongoingRequest = new OngoingRequest(deferredPromises, callContext);
                ongoingRequest.resolveNotification();
            }
        }
    }
    async onIncomingMessage(rpcMessage, callContext) {
        logger.trace(`onIncomingMessage, requestId: ${rpcMessage.requestId}`);
        if (rpcMessage.header.response && this.ongoingRequests.has(rpcMessage.requestId)) {
            if (rpcMessage.errorType !== undefined) {
                this.rejectOngoingRequest(rpcMessage);
            }
            else {
                this.resolveOngoingRequest(rpcMessage);
            }
        }
        else if (rpcMessage.header.request && rpcMessage.header.method) {
            if (rpcMessage.header.notification) {
                await this.handleNotification(rpcMessage, callContext);
            }
            else {
                await this.handleRequest(rpcMessage, callContext);
            }
        }
    }
    async handleRequest(rpcMessage, callContext) {
        if (this.stopped) {
            return;
        }
        let response;
        try {
            const bytes = await this.rpcServerRegistry.handleRequest(rpcMessage, callContext);
            response = this.createResponseRpcMessage({
                request: rpcMessage,
                body: bytes
            });
        }
        catch (err) {
            const errorParams = { request: rpcMessage };
            if (err.code === ErrorCode.UNKNOWN_RPC_METHOD) {
                errorParams.errorType = RpcErrorType.UNKNOWN_RPC_METHOD;
            }
            else if (err.code === ErrorCode.RPC_TIMEOUT) {
                errorParams.errorType = RpcErrorType.SERVER_TIMEOUT;
            }
            else {
                errorParams.errorType = RpcErrorType.SERVER_ERROR;
                if (err.className) {
                    errorParams.errorClassName = err.className;
                }
                if (err.code) {
                    errorParams.errorCode = err.code;
                }
                if (err.message) {
                    errorParams.errorMessage = err.message;
                }
            }
            response = this.createResponseRpcMessage(errorParams);
        }
        this.onOutgoingMessage(response, callContext, undefined);
    }
    async handleNotification(rpcMessage, callContext) {
        if (this.stopped) {
            return;
        }
        try {
            await this.rpcServerRegistry.handleNotification(rpcMessage, callContext);
        }
        catch (err) {
            logger.debug('error', { err });
        }
    }
    registerRequest(requestId, deferredPromises, callContext, timeout = this.rpcRequestTimeout) {
        if (this.stopped) {
            return;
        }
        const ongoingRequest = new OngoingRequest(deferredPromises, callContext, {
            timeout,
            onTimeout: () => this.ongoingRequests.delete(requestId)
        });
        this.ongoingRequests.set(requestId, ongoingRequest);
    }
    resolveOngoingRequest(response) {
        if (this.stopped) {
            return;
        }
        const ongoingRequest = this.ongoingRequests.get(response.requestId);
        ongoingRequest.resolveRequest(response);
        this.ongoingRequests.delete(response.requestId);
    }
    rejectOngoingRequest(response) {
        if (this.stopped) {
            return;
        }
        const ongoingRequest = this.ongoingRequests.get(response.requestId);
        let error;
        if (response.errorType === RpcErrorType.SERVER_TIMEOUT) {
            error = new RpcTimeout('Server timed out on request');
        }
        else if (response.errorType === RpcErrorType.UNKNOWN_RPC_METHOD) {
            error = new UnknownRpcMethod$1(`Server does not implement method ${response.header.method}`);
        }
        else if (response.errorType === RpcErrorType.SERVER_ERROR) {
            error = new RpcServerError(response.errorMessage, response.errorClassName, response.errorCode);
        }
        else {
            error = new RpcRequest('Unknown RPC Error');
        }
        ongoingRequest.rejectRequest(error, StatusCode.SERVER_ERROR);
        this.ongoingRequests.delete(response.requestId);
    }
    handleClientError(requestId, error) {
        if (this.stopped) {
            return;
        }
        const ongoingRequest = this.ongoingRequests.get(requestId);
        if (ongoingRequest) {
            ongoingRequest.rejectRequest(error, StatusCode.SERVER_ERROR);
            this.ongoingRequests.delete(requestId);
        }
    }
    setOutgoingMessageListener(listener) {
        this.outgoingMessageListener = listener;
    }
    getRequestIds(predicate) {
        return Array.from(this.ongoingRequests.entries()).filter(([_, request]) => request.fulfillsPredicate(predicate)).map(([id]) => id);
    }
    // eslint-disable-next-line class-methods-use-this
    createResponseRpcMessage({ request, body, errorType, errorClassName, errorCode, errorMessage }) {
        return {
            body,
            header: {
                response: 'response',
                method: request.header.method
            },
            requestId: request.requestId,
            errorType,
            errorClassName,
            errorCode,
            errorMessage
        };
    }
}

/* eslint-disable prefer-spread, @typescript-eslint/consistent-indexed-object-style */
function toProtoRpcClient(orig) {
    const ret = {};
    Object.assign(ret, orig);
    const notify = async (methodName, obj, args) => {
        if (args.length < 2) {
            args.push({});
        }
        else {
            args[1] ??= {};
        }
        args[1].isProtoRpc = true;
        args[1].notification = true;
        await obj[methodName].apply(obj, args);
    };
    const callRpc = (methodName, obj, args) => {
        if (args.length < 2) {
            args.push({});
        }
        else {
            args[1] ??= {};
        }
        args[1].isProtoRpc = true;
        return obj[methodName].apply(obj, args);
    };
    orig.methods.forEach((method) => {
        if (method.O.typeName === Empty.typeName) {
            ret[method.name] = (...args) => {
                return notify(method.name, orig, args);
            };
        }
        else {
            ret[method.name] = (...args) => {
                return callRpc(method.name, orig, args).response;
            };
        }
    });
    return ret;
}

const protoClasses = [RpcMessage];

export { ClientTransport, ProtoCallContext, RpcCommunicator, errors as RpcError, RpcMessage, StatusCode, protoClasses, toProtoRpcClient };
//# sourceMappingURL=exports.js.map
